import { scrollToRef } from "./utils";

export function scrollToField(errors, fieldRefs) {
    let fieldRef;

    if (!errors || !fieldRefs) {
        return;
    }
    // Find name of first error.
    const {
        quantityValueRef,
        personalMessageRef,
        packagingRef,
        giftWrapRef,
        upsellRef,
        configRef
    } = fieldRefs;

    const field = Object.keys(errors)?.[0];

    // Set field ref to that field.
    switch (field) {
        case "value":
        case "sku":
            fieldRef = quantityValueRef;
            break;
        case "personalMessage":
            fieldRef = personalMessageRef;
            break;
        case "packaging":
            fieldRef = packagingRef;
            break;
        case "giftWrap":
            fieldRef = giftWrapRef;
            break;
        case "upsell":
            fieldRef = upsellRef;
            break;
        default:
            fieldRef = configRef;
            break;
    }

    // Scroll to field
    scrollToRef(fieldRef);
}

export const mapCartToForm = (optionItems, items) => {
    return (
        optionItems?.map(optionItem => {
            const option = {
                quantity: 0,
                sku: optionItem?.variants?.edges?.[0]?.sku
            };

            const optionInCart = items.find(
                cartItem =>
                    cartItem?.variant?.sku ===
                    optionItem?.variants?.edges?.[0]?.sku
            );

            if (optionInCart) {
                option.quantity = optionInCart.quantity;
            }

            return option;
        }) ?? []
    );
};

export function formDataToVariables(data) {
    const variables = {
        sku: undefined,
        quantity: 0,
        personalMessage: false,
        message: undefined,
        packaging: [],
        upsell: [],
        giftwrap: false
    };
    const { sku, quantity, personalMessage, giftWrap } = data;

    if (sku) {
        variables.sku = sku;
    }

    if (quantity) {
        variables.quantity = parseInt(quantity, 10);
    }

    if (data?.packaging?.checked && data?.packaging?.items) {
        variables.packaging = data.packaging.items
            .filter(item => Number(item.quantity) > 0)
            ?.map(item => ({
                sku: item.sku,
                quantity: Number(item.quantity)
            }));
    }

    if (data?.upsell?.checked && data?.upsell?.items) {
        variables.upsell = data.upsell.items
            .filter(item => Number(item.quantity) > 0)
            ?.map(item => ({
                sku: item.sku,
                quantity: Number(item.quantity)
            }));
    }

    if (personalMessage?.checked && personalMessage?.message?.length > 0) {
        variables.personalMessage = !!personalMessage.checked;
    }

    if (
        personalMessage?.checked &&
        personalMessage?.message &&
        personalMessage?.message?.length > 0
    ) {
        variables.message = personalMessage.message;
    }

    if (giftWrap?.enabled) {
        variables.giftwrap = giftWrap.enabled;
    }
    return {
        variables
    };
}
